import React, { FC } from 'react';
import { MotifTabNavigation as MotifTabNav, MotifTabControl } from '@ey-xd/motif-react';
import PropTypes from 'prop-types';

type TabNavigationProps = {
    tabs: string[];
    className?: string;
    onTabClick: (tab: string) => void;
};

const TabNavigation: FC<TabNavigationProps> = ({
    tabs,
    className,
    onTabClick
}: TabNavigationProps) => {
    return (
        <MotifTabNav defaultActiveKey={0} className={className}>
            {tabs.map((tab) => (
                <MotifTabControl key={tab} onClick={() => onTabClick(tab)}>
                    {tab}
                </MotifTabControl>
            ))}
        </MotifTabNav>
    );
};

export default TabNavigation;
